var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFullscreenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48.466,
    height: 48.466,
    viewBox: "0 0 48.466 48.466",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{filter:url(#a);}"), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 48.466,
    height: 48.466,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "matrix(1, 0, 0, 1, 0, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M11.852,27.085H7.5V37.966H18.381V33.614H11.852ZM7.5,18.381h4.352V11.852h6.528V7.5H7.5ZM33.614,33.614H27.085v4.352H37.966V27.085H33.614ZM27.085,7.5v4.352h6.528v6.528h4.352V7.5Z",
    transform: "translate(1.5 -1.5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullscreenIcon);
export default __webpack_public_path__ + "static/media/fullscreen-icon.e19e41c62386cf10b135714f7d790238.svg";
export { ForwardRef as ReactComponent };